var _defs, _rect, _path, _circle, _g, _text, _text2, _text3, _circle2, _g2, _text4, _text5, _text6, _circle3, _g3, _text7, _text8, _text9, _circle4, _g4, _text0, _text1, _text10, _circle5, _g5, _text11, _text12, _text13, _circle6, _g6, _text14, _text15, _text16, _rect2, _circle7, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreAccountabilityLoopDesktopSequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1240,
    height: 340,
    viewBox: "0 0 1240 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore accountability loop desktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcalLine",
    x1: 80,
    y1: 0,
    x2: 1160,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#80C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1238,
    height: 338,
    rx: 28,
    fill: "#FFFFFF",
    stroke: "#C8D9ED",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 145H1140",
    stroke: "url(#fcalLine)",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 145,
    r: 48,
    fill: "#EDF6FF",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68 113)"
  }, /*#__PURE__*/React.createElement("title", null, "FleetCore accountability loop driver icon"), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 8,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 49c1-13 6-19 16-19s15 6 16 19",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 51,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.4
  }, "01")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 222,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "DRIVER")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 246,
    textAnchor: "middle",
    fill: "#62758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Identity and credentials")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 308,
    cy: 145,
    r: 48,
    fill: "#FFF1F6",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(276 113)"
  }, /*#__PURE__*/React.createElement("title", null, "FleetCore accountability loop vehicle icon"), /*#__PURE__*/React.createElement("path", {
    d: "M10 39h38l-4-15H18l-8 15Zm4 0v7m30-7v7",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 40,
    r: 4,
    fill: "#FF2775"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 4,
    fill: "#FF2775"
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 308,
    y: 51,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.4
  }, "02")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 308,
    y: 222,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "VEHICLE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 308,
    y: 246,
    textAnchor: "middle",
    fill: "#62758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Registration and baseline")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 145,
    r: 48,
    fill: "#EDF6FF",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(484 113)"
  }, /*#__PURE__*/React.createElement("title", null, "FleetCore accountability loop shift icon"), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 20,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 15v14l10 6",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 51,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.4
  }, "03")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 222,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "SHIFT")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 246,
    textAnchor: "middle",
    fill: "#62758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Check-in and check-out")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 724,
    cy: 145,
    r: 48,
    fill: "#FFF1F6",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(692 113)"
  }, /*#__PURE__*/React.createElement("title", null, "FleetCore accountability loop fuel icon"), /*#__PURE__*/React.createElement("path", {
    d: "M15 10h24v40H15zM20 17h14v11H20zM39 18h6l4 6v22c0 5 7 5 7 0V24",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 51,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.4
  }, "04")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 222,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "FUEL")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 246,
    textAnchor: "middle",
    fill: "#62758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Litres and readings")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 932,
    cy: 145,
    r: 48,
    fill: "#EDF6FF",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900 113)"
  }, /*#__PURE__*/React.createElement("title", null, "FleetCore accountability loop intelligence icon"), /*#__PURE__*/React.createElement("path", {
    d: "M10 44h38M16 38l8-11 8 6 12-18",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 15,
    r: 4,
    fill: "#087CFF"
  }))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 932,
    y: 51,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.4
  }, "05")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 932,
    y: 222,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "INTELLIGENCE")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 932,
    y: 246,
    textAnchor: "middle",
    fill: "#62758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Expected vs actual")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1140,
    cy: 145,
    r: 48,
    fill: "#FFF1F6",
    stroke: "#FF2775",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1108 113)"
  }, /*#__PURE__*/React.createElement("title", null, "FleetCore accountability loop action icon"), /*#__PURE__*/React.createElement("path", {
    d: "M28 8 48 17v15c0 14-8 22-20 28C16 54 8 46 8 32V17l20-9Z",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 33 7 7 14-17",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1140,
    y: 51,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.4
  }, "06")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1140,
    y: 222,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "ACTION")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1140,
    y: 246,
    textAnchor: "middle",
    fill: "#62758F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Exception reviewed")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 282,
    width: 552,
    height: 38,
    rx: 19,
    fill: "#07152A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 301,
    r: 5,
    fill: "#FF2775"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 385,
    y: 306,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 730
  }, "Every stage remains connected to the same operational event.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreAccountabilityLoopDesktopSequence);
export default __webpack_public_path__ + "static/media/fleetcore-accountability-loop-desktop-sequence.a4cda39156698135221a17a1cb1ab290.svg";
export { ForwardRef as ReactComponent };